import { ENV } from "../utils";

export class Cita {
  baseApi = ENV.BASE_API;

  async getProximas(accessToken, limit = 20) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.CITAS}/proximas?limit=${limit}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async getByDocumento(accessToken, documentoId) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.CITAS}/documento/${documentoId}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async create(accessToken, documentoId, body) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.CITAS}/documento/${documentoId}`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (res.status !== 201) throw data;
    return data;
  }

  async update(accessToken, id, body) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.CITAS}/${id}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async cancelarPorCandidato(accessToken, documentoId) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.CITAS}/cancelar-por-candidato/${documentoId}`, {
      method: "PATCH",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async marcarRealizadaPorCandidato(accessToken, documentoId) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.CITAS}/marcar-realizada/${documentoId}`, {
      method: "PATCH",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async remove(accessToken, id) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.CITAS}/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }
}
